module.exports = __webpack_public_path__ + "static/patient-support-dose-exchange-3f6528f99b0cfa2594f5bb1eefc65b0f.png";